// @generated - Do not edit: this file is autogenerated by:
//   //dropbox/pap/codegen
//
// Event definition: https://pap.pp.dropbox.com/#/events/3471
import type { PAPEventGeneric } from "../base/event";
import type { ActionSurfaceComponent } from "../enums/action_surface_component";
import type { BrowserName } from "../enums/browser_name";
import type { DashActionSurface } from "../enums/dash_action_surface";
import type { Environment } from "../enums/environment";
import type { FeatureLine } from "../enums/feature_line";
import type { OperatingSystem } from "../enums/operating_system";

// Event_name: 'click.export_button'
// Description: Export content from assist
// Owner: dash-web
export type Click_ExportButton = PAPEventGeneric<
  'dash_assist',
  'click',
  'export_button',
  {
    // The component within a surface in which an action was taken on Dash.
    actionSurfaceComponent?: ActionSurfaceComponent;
    // This indicates the user's current browser
    browserName?: BrowserName;
    // generic property representing build version of whatever is logging this event.
    buildVersion?: string;
    // The surface in which an action was taken on Dash.
    // Note: serp and search_result_page are the same thing, but we're only using serp moving forward.
    dashActionSurface?: DashActionSurface;
    // Whether the app dispatching the event is Prod, Test, or Dev (run locally by the developer)
    environment?: Environment;
    // Feature Line for dash
    featureLine?: FeatureLine;
    // Boolean event property that is set to true for Dash for Business (dfb) users.
    isDfbUser?: boolean;
    // The operating system platform the user is running on.
    operatingSystem?: OperatingSystem;
    // the start time of the event in ms
    startTimeMs?: number;
    // A list of actions users can do on the web
    actionType?: string;
    // fresh id that gets generated for every new session or instance of the chat window
    chatSessionId?: string;
    // unique id generated by the server for an assist request. Used by the ML team to link user actions on an assistant response and get feedback on usefulness of the response
    assistRequestId?: string;
  }
>;

export function PAP_Click_ExportButton(properties?: Click_ExportButton['properties']): Click_ExportButton {
  return <Click_ExportButton>{
    class: 'dash_assist',
    action: 'click',
    object: 'export_button',
    properties,
  };
}
